<template>
  <section v-if="show" style="width:100%;min-height:100%" class="flex-col">
    
    <com-nav></com-nav>

    <section style="width:100%;height:100%">
      <keep-alive>
        <router-view  />
      </keep-alive>
    </section>

    
    <com-footer></com-footer>
    

  </section>
</template>
<script>

import comNav from '@/components/nav';
import comFooter from '@/components/footer';
import mixin from '@/plugin/mixin';

export default {
  mixins: [mixin],
  name: "homeTab",
  computed: {
  },
  mounted() {
    this.show=true;
  },
  activated() {
    // this.resetTabIndex(this.$route.name);

  },
  data() {
    return {
      show:false,
      bottomTabIndex: 0,
    };
  },
  methods: {
    
  },
  components: {
    comNav,comFooter
  }
};

</script>
<style lang="scss">

</style>
<style scoped lang="scss">

</style>
